module.exports = __webpack_public_path__ + "img/A12.e2051e02.svg";